import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { api } from "../lib/api";
import { toast } from "sonner";

// One-shot handler invoked when the URL contains `#session_id=...`.
// Exchanges the temporary session id against a persistent server session,
// then redirects the user to the home page (replace history so the fragment
// disappears and the callback cannot fire twice).
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { exchangeSession } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }
    (async () => {
      try {
        const user = await exchangeSession(sessionId);
        toast.success(`Bienvenue ${user?.name || user?.email || ""}`.trim());
        // Resume a pending purchase if the user was redirected to login mid-buy
        const intent = sessionStorage.getItem("otra_buy_intent");
        if (intent === "generic") {
          sessionStorage.removeItem("otra_buy_intent");
          try {
            const { data } = await api.post("/payments/checkout/session", {
              origin_url: window.location.origin,
            });
            window.location.href = data.url;
            return;
          } catch (e) {
            // fall through to normal navigation
          }
        }
        navigate(user?.role === "admin" ? "/admin" : "/", { replace: true });
      } catch (e) {
        toast.error("Connexion Google échouée");
        navigate("/login", { replace: true });
      }
    })();
  }, [location.hash, navigate, exchangeSession]);

  return (
    <div
      className="min-h-screen flex items-center justify-center text-cyan-200/70 font-display tracking-widest"
      data-testid="auth-callback-loading"
    >
      CONNEXION EN COURS...
    </div>
  );
}
